import m from "../../geodata/es2015/russiaLow";
window.am4geodata_russiaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/russiaLow.js
// module id = null
// module chunks = 